import { useCallback, useEffect, useRef, useState } from 'react';

interface UseCooldownResult {
  isCoolingDown: boolean;
  triggerCooldown: () => void;
}

export function useCooldown(durationMs: number): UseCooldownResult {
  const [isCoolingDown, setIsCoolingDown] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const triggerCooldown = useCallback(() => {
    setIsCoolingDown(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setIsCoolingDown(false);
      timeoutRef.current = null;
    }, durationMs);
  }, [durationMs]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    isCoolingDown,
    triggerCooldown,
  };
}
